import CryptoJS from 'crypto-js'

// DES 加密
export const DES_ENCODE = (message, key = 'house-data') => {
  if (!message) return ''
  message = typeof message === 'number' ? message + '' : message
  const keyHex = CryptoJS.enc.Utf8.parse(key)
  const encrypted = CryptoJS.DES.encrypt(message, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  // 后端要求传输不能有特殊字符
  return encodeURIComponent(encrypted.toString())
}

// DES 解密
export const DES_DECODE = (ciphertext, key = 'house-data') => {
  if (!ciphertext) return ''
  const deCiphertext = decodeURIComponent(ciphertext)
  const keyHex = CryptoJS.enc.Utf8.parse(key)
  let decrypted;
  if(deCiphertext === ciphertext) {
    decrypted = buildCiphertext(ciphertext, keyHex)
    return decrypted.toString(CryptoJS.enc.Utf8)
  }
  decrypted = buildCiphertext(deCiphertext, keyHex)
  let deDecrypted = buildCiphertext(ciphertext, keyHex)
  return decrypted.toString(CryptoJS.enc.Utf8) || deDecrypted.toString(CryptoJS.enc.Utf8) || ciphertext
}

function buildCiphertext(text, keyHex) {
  text = typeof text === 'number' ? text + '' : text
  return CryptoJS.DES.decrypt({
    ciphertext: CryptoJS.enc.Base64.parse(text)
  }, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
}

export default {
  DES_ENCODE,
  DES_DECODE
}
